import { OfferReport } from "components/Report/OfferReport/OfferReport.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getReportHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/report/_layout/offer/")({
    component: OffersReportPage,
    staticData: {
        permissions: [PermissionEnum.ReportOffer],
        showInSideMenu: false,
        label: "pages.report.offer.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.report.offer.title"),
        };
    },
});

function OffersReportPage() {
    return (
        <TenantPage headerNavigationItems={getReportHeaderItems}>
            <OfferReport />
        </TenantPage>
    );
}
